var path = 'jangl/jangl-textarea/template.html';
var html = "<div class=form-group> <label for={{$ctrl.name}} class=control-label ng-class=\"{ 'required': $ctrl.required }\">{{$ctrl.label}}</label> <textarea class=form-control name={{$ctrl.name}} ng-model=$ctrl.model ng-required=$ctrl.required required></textarea> <div class=error-messages ng-show=$ctrl.form.$submitted> <div ng-repeat=\"err in $ctrl._errorMessages\" ng-show=$ctrl.form[$ctrl.name].$error[err.type]>{{err.msg}}</div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/jangl/jangl-textarea/template.html
// module id = 379
// module chunks = 0